module.exports = __webpack_public_path__ + "static/media/act3.3ccb0029.jpg";